export enum SetupStoreId {
  App = 'app-store',
  Theme = 'theme-store',
  Auth = 'auth-store',
  Route = 'route-store',
  Tab = 'tab-store',
  Notify = 'notify-store'
}

/** 平台 */
export enum PlatformEnum {
  /** 睿和云店 */
  HE_HE = 1000
}
/** 平台组织机构代码 */
export enum PlatformDepartmentCodeEnum {
  HE_HE = 100
}

/** 角色枚举 */
export enum RoleEnum {
  /** 超级管理员 */
  SUPER_ADMIN = 100,
  /** 平台管理员 */
  PLATFORM_ADMIN = 110,
  /** 平台董事长 */
  PLATFORM_SENIOR_MANAGER = 111,
  /** 平台总经理 */
  PLATFORM_MANAGER = 118,
  /** 平台财务 */
  PLATFORM_FINANCE = 119,
  /** 后勤客服 */
  CUSTOMER_SERVICE = 115,
  /** 平台仓库管理层 */
  PLATFORM_INVENTORY_MANAGER = 116,
  /** 平台-销售客服 */
  PLATFORM_SALE_SERVICE = 117,
  /** 大客户经理 */
  SUPER_CUSTOMER_MANAGER = 120,
  /** 客户经理 */
  CUSTOMER_MANAGER = 130,
  /** 客户账户管理员 */
  CUSTOMER_ADMIN = 140,
  /** 组织-董事长 */
  CUSTOMER_CHAIRMAN = 141,
  /** 组织-总经理 */
  CUSTOMER_SUPER_MANAGER = 142,
  /** 组织-运营经理 */
  CUSTOMER_OPERATION_MANAGER = 143,
  /** 客服 */
  CUSTOMER_SERVICE_ORG = 144,
  /** 督导 */
  CUSTOMER_SUPERVISION = 145,
  /** 库存盘点 */
  CUSTOMER_INVENTORY_TAKER = 146,
  /** 门店店长 */
  STORE_MANAGER = 200,
  /** 门店财务 */
  STORE_FINANCE = 210,
  /** 门店销售 */
  STORE_SALE = 211,
  /** 门店采购 */
  STORE_PURCHASE = 212,
  /** 门店仓管 */
  STORE_INVENTORY = 213,
  /** 门店技师 */
  STORE_TECHNICIAN = 214,
  /** 门店会员 */
  STORE_MEMBER = 215,
  /** 门店合伙人 */
  STORE_PARTNER = 216,
  /** 车间主管 */
  STORE_LEADER = 217,
  /** 后勤客服 */
  STORE_LOGISTICS = 219,
  /** 门店合伙人店长 */
  STORE_PARTNER_MANAGER = 300,
  /** 4S店长 */
  VEHICLE_MANAGER = 500,
  /** 4S销售 */
  VEHICLE_SALE = 505,
  /** 普通客户-客服 */
  NORMAL_SERVICE = 605,
  /** 普通客户-财务 */
  NORMAL_FINANCE = 610,
  /** 普通客户-采购 */
  NORMAL_PURCHASE = 615,
  /** 普通客户-仓管 */
  NORMAL_INVENTORY = 620,
  /** 经销商 */
  DEALER = 250,
  /** 经销商区域经理 */
  DEALER_AREA_MANAGER = 251,
  /** 经销商销售 */
  DEALER_SALE = 252,
  /** 项目组长 */
  FACTORY_LEADER = 400,
  /** 项目组客服 */
  FACTORY_SERVICE = 405,
  /** 主机厂-售后总经理 */
  FACTORY_SUPER_MANAGER = 401,
  /** 主机厂-售后经理 */
  FACTORY_MANAGER = 402,
  /** 主机厂-服务总监 */
  FACTORY_SERVICE_DIRECTOR = 403,
  /** 主机厂-服务经理 */
  FACTORY_SERVICE_MANAGER = 404
}
/** 角色类型 */
export enum RoleTypeEnum {
  /** 系统角色 */
  SYSTEM = 0,
  /** 平台(工厂)角色 */
  PLATFORM = 1,
  /** 客户角色 */
  CUSTOMER = 2,
  /** 门店角色 */
  STORE = 3,
  /** 合作门店角色 */
  PARTNER = 4,
  /** 主机厂项目组 */
  FACTORY_TEAM = 5,
  /** 4S店 */
  VEHICLE = 6,
  /** 普通客户 */
  NORMAL = 7,
  /** 经销商角色 */
  DEALER = 8
}

/** 组织类型 */
export enum DepartmentTypeEnum {
  /** 平台 */
  PLATFORM = 1,
  /** 门店 */
  STORE = 3,
  /** 合作门店 */
  PARTNER = 4,
  /** 主机厂项目组 */
  FACTORY = 5,
  /** 4S店 */
  VEHICLE = 6,
  /** 经销商 */
  DEALER = 7
}
/** 字典类型 */
export enum DictTypeEnum {
  /** 合同类型 */
  CONTRACT_TYPE = 'CONTRACT_TYPE',
  /** 产品品名 */
  PRODUCT_NAME = 'PRODUCT_NAME',
  /** 产品型号 */
  PRODUCT_VERSION = 'PRODUCT_VERSION',
  /** 产品规格 */
  PRODUCT_SPEC = 'PRODUCT_SPEC',
  /** 产品单位 */
  PRODUCT_UNIT = 'PRODUCT_UNIT',
  /** 产品销售单位 */
  PRODUCT_SALE_UNIT = 'PRODUCT_SALE_UNIT',
  /** 供应商型号 */
  SUPPLIER_VERSION = 'SUPPLIER_VERSION',
  /** 课程大类 */
  COURSE_CATEGORY = 'COURSE_CATEGORY',
  /** 施工部位 */
  CONSTRUCTION_SITE = 'CONSTRUCTION_SITE',
  /** 支付方式 */
  PAYMENT_TYPE = 'PAYMENT_TYPE',
  /** 套餐未升级类型 */
  PACKAGE_NOT_UPGRADE = 'PACKAGE_NOT_UPGRADE',
  /** 预约流失类型 */
  APPOINTMENT_LOSS_TYPE = 'APPOINTMENT_LOSS_TYPE',
  /** 客户来源 */
  CUSTOMER_SOURCE = 'CUSTOMER_SOURCE',
  /** 小程序渠道 */
  MINIAPP_CHANNEL = 'MINIAPP_CHANNEL',
  /** u8部门 */
  U8_DEPARTMENT = 'U8_DEPARTMENT',
  /** 配件类型 */
  CM_CATEGORY = 'CM_CATEGORY'
}
/** 钱包类型 ACCOUNT("用户", 1), CUSTOMER("客户", 2), EMPLOYEE("员工", 3), */
export enum WalletTypeEnum {
  /** 用户 */
  ACCOUNT = 1,
  /** 客户 */
  CUSTOMER = 2,
  /** 员工 */
  EMPLOYEE = 3,
  PARTNER = 4,
  /** 4s */
  VEHICLE = 5
}
/** 交易流向 */
export enum TransactionFlowEnum {
  IN = 1,
  OUT = 2
}
/**
 * 交易类型
 *
 * COMMISSION_SERVICE_ITEM("工时提成", TransactionFlowEnum.IN, 1), COMMISSION_PRODUCT_INFO("车膜提成",
 * TransactionFlowEnum.IN,2), COMMISSION_PRODUCT_SKU("商品提成", TransactionFlowEnum.IN,3), COMMISSION_SALE_PRICE("订单提成",
 * TransactionFlowEnum.IN,4), COMMISSION_PARTNER("合伙人提成", TransactionFlowEnum.IN,5),
 * COMMISSION_SERVICE_CUSTOMER("服务官提成", TransactionFlowEnum.IN,10), COMMISSION_RECOMMEND_CUSTOMER("推荐官提成",
 * TransactionFlowEnum.IN,11), COMMISSION_CUSTOMER_MANAGER("客户经理提成", TransactionFlowEnum.IN,12),
 * WITHDRAW_EMPLOYEE("员工提现", TransactionFlowEnum.OUT, 100),
 */
export enum TransactionTypeEnum {
  COMMISSION_SERVICE_ITEM = 1,
  COMMISSION_PRODUCT_INFO = 2,
  COMMISSION_PRODUCT_SKU = 3,
  COMMISSION_SALE_PRICE = 4,
  COMMISSION_PARTNER = 5,
  COMMISSION_VEHICLE = 6,
  COMMISSION_SERVICE_CUSTOMER = 10,
  COMMISSION_RECOMMEND_CUSTOMER = 11,
  COMMISSION_CUSTOMER_MANAGER = 12,
  WITHDRAW_EMPLOYEE = 100
}

/** 员工类型 */
export enum StoreEmployeeTypeEnum {
  TECHNICIAN = 1,
  SALE = 2,
  PARTNER = 3,
  VEHICLE = 4
}

/** 产品类型 */
export enum ProductTypeEnum {
  /** 窗膜 */
  WINDOW_FILM = 1,
  /** 车衣 */
  CAR_COVER = 2,
  /** 改色膜 */
  WRAP_FILM = 3
}

/** 门店提成类别 */
export enum StoreCommissionType {
  /** 工时提成 */
  SERVICE_ITEM = 1,
  /** 车膜提成 */
  PRODUCT_INFO = 2,
  /** 商品提成 */
  PRODUCT_SKU = 3,
  /** 订单提成 */
  SALE_PRICE = 4,
  /** 合伙人提成 */
  PARTNER = 5,
  /** 4S店提成 */
  VEHICLE = 6
}

export enum TypeName {
  STRING = 'String',
  NUMBER = 'Number',
  DATE = 'DATE'
}

/** 树根节点类型 */
export enum TreeRootTypeEnum {
  // 当前用户作为根节点
  CURRENT = 1,
  // 当前用户的上级平台作为根节点
  SUB_PLATFORM = 2
}

/** 树类型枚举 */
export enum TreeTypeEnum {
  /** 组织架构树 */
  DEPARTMENT = 1,
  /** 客户经理树 */
  MANAGER = 2,
  /** 推荐官 */
  RECOMMEND = 3,
  /** 服务官 */
  SERVICE = 4,
  /** 客户树 */
  CUSTOMER = 5,
  /** 仓库树 */
  WAREHOUSE = 6
}

/** 客户信息枚举 */
// WAIT_APPOINTMENT("待预约", 10),
//     APPOINTMENT_ONE("一次预约", 20),
//     APPOINTMENT_SECOND("二次预约", 21),
//     APPOINTMENT_THIRD("三次预约", 22),
//     WAIT_COMPLETE_INFO("待完善信息", 25),
//     WAIT_DISPATCH("待分配", 30),
//     WAIT_AUDIT("待审核", 32),
//     LOSS("已流失", 34),
//     WAIT_STORE_ALLOCATION("门店待分配", 40),
//     WAIT_STORE_APPOINTMENT("门店待预约", 42),
//     ON_STORE_APPOINTMENT("门店预约中", 44),
//     WAIT_STORE_VERIFIED("门店待核销", 50),
//     IN_STORE_CONSTRUCTION("门店施工中", 60),
//     STORE_LOSS("门店流失", 70),
//     DONE("已完成", 100),
export enum StoreCustomerStatusEnum {
  // 待预约
  WAIT_APPOINTMENT = 10,
  // 一次预约
  APPOINTMENT_ONE = 20,
  // 二次预约
  APPOINTMENT_SECOND = 21,
  // 三次预约
  APPOINTMENT_THIRD = 22,
  // 待完善信息
  WAIT_COMPLETE_INFO = 25,
  // 待分配
  WAIT_DISPATCH = 30,
  // 待审核
  WAIT_AUDIT = 32,
  // 已分配（仅用于展示，过滤需特殊处理）
  DISPATCHED = 33,
  // 已流失
  LOSS = 34,
  // 门店待分配
  WAIT_STORE_ALLOCATION = 40,
  // 门店待预约
  WAIT_STORE_APPOINTMENT = 42,
  // 门店预约中
  ON_STORE_APPOINTMENT = 44,
  // 门店待核销
  WAIT_STORE_VERIFIED = 50,
  // 门店施工中
  IN_STORE_CONSTRUCTION = 60,
  // 门店流失
  STORE_LOSS = 70,
  // 已完成
  DONE = 100
}

// 主机厂客户预约事件枚举
export enum StoreCustomerEventEnum {
  // 流失
  LOSS = -10,
  // 流失审核通过
  AUDIT_LOSS_RESOLVE = -15,
  // 流失审核拒绝
  AUDIT_LOSS_REJECT = -16,
  // 初始化
  INIT = 0,
  // 预约
  APPOINTMENT = 10,
  // 预约成功
  APPOINTMENT_SUCCESS = 15,
  // 分配
  DISPATCH = 20,
  // 撤回
  REVERT = 30,
  // 门店分配
  STORE_ALLOCATION = 40,
  // 门店预约
  STORE_APPOINTMENT = 42,
  // 门店流失
  STORE_LOSS = 44,
  // 门店取消预约
  STORE_CANCEL = 46,
  // 门店核销
  STORE_VERIFIED = 50,
  // 门店取消核销
  STORE_CANCEL_VERIFIED = 60,
  // 完工
  DONE = 100
}

/** 预约记录状态枚举 */
export enum AppointmentRecordStatusEnum {
  // 客户同意
  AGREED = 1,
  // 客户拒绝
  REFUSED = 2,
  // 已接通
  CONNECTED = 3,
  // 未接通
  NOT_CONNECTED = 4
}

/** 预约单状态枚举 */
export enum StoreAppointmentStateEnum {
  // 已过期
  EXPIRED = -40,
  // 已流失
  LOSS = -30,
  // 待审核流失
  WAIT_AUDIT_LOSS = -25,
  // 待审核取消
  WAIT_AUDIT_CANCEL = -15,
  // 待分配
  WAIT_ALLOCATION = 0,
  // 待预约
  WAIT_APPOINTMENT = 10,
  // 预约中
  ON_APPOINTMENT = 20,
  // 待审核修改
  WAIT_AUDIT_EDIT = 25,
  // 待核销
  WAIT_VERIFIED = 30,
  // 施工中
  IN_CONSTRUCTION = 40,
  // 已完成
  DONE = 100
}

/** 预约单事件枚举 */
export enum StoreAppointmentEventEnum {
  // 过期
  EXPIRED = -40,
  // 流失
  LOSS = -30,
  // 审核流失通过
  AUDIT_LOSS_RESOLVE = -25,
  // 审核流失拒绝
  AUDIT_LOSS_REJECT = -26,
  // 取消
  CANCEL = -20,
  // 审核取消通过
  AUDIT_CANCEL_RESOLVE = -15,
  // 审核取消拒绝
  AUDIT_CANCEL_REJECT = -16,
  // 初始化
  INIT = 0,
  // 分配
  ALLOCATION = 10,
  // 预约
  APPOINTMENT = 20,
  // 修改
  EDIT = 30,
  // 审核修改通过
  AUDIT_EDIT_RESOLVE = 35,
  // 审核修改拒绝
  AUDIT_EDIT_REJECT = 36,
  // 核销
  VERIFIED = 50,
  // 完工
  DONE = 100
}

/** U8客户类别 */
export enum U8CCCodeEnum {
  // 隐形车衣
  TH_05 = '05',
  // 窗膜
  TH_07 = '07',
  // 其他
  TH_99 = '99'
}

/** 销售订单支付方式 */
export enum OrderPaymentTypeEnum {
  // 挂账
  PENDING = 0,
  // 支付宝
  ALIPAY = 1,
  // 微信
  WECHAT = 2,
  // 银行卡
  BANK = 3,
  // 现金
  CASH = 4,
  // 对公打款
  PUBLIC = 5,
  // DF收款
  DF = 6,
  // 积分
  POINT = 7,
  // 美团
  MT = 8,
  // 抖音
  DY = 9
}

/** 销售订单支付方式 */
export enum OrderCreditPaymentTypeEnum {
  // 支付宝
  ALIPAY = 1,
  // 微信
  WECHAT = 2,
  // 银行卡
  BANK = 3,
  // 现金
  CASH = 4,
  // 对公打款
  PUBLIC = 5,
  // DF收款
  DF = 6,
  // 积分
  POINT = 7,
  // 美团
  MT = 8,
  // 抖音
  DY = 9
}

/** 车膜采购订单状态枚举 */
export enum FilmPurchaseOrderStateEnum {
  // 已撤销
  REVERT = -20,
  // 退回
  REJECT = -10,
  // 待提交
  WAIT_SUBMIT = 10,
  // 待审核
  WAIT_AUDIT = 20,
  // 待甲方签订合同
  WAIT_FIRST_PARTY_SIGN = 25,
  // 待乙方签订合同
  WAIT_SECOND_PARTY_SIGN = 30,
  // 待收款
  WAIT_PAYMENT = 40,
  // 待采购
  WAIT_PURCHASE = 50,
  // 采购中
  IN_PURCHASE = 60,
  // 待出库
  WAIT_OUTBOUND = 70,
  // 出库中
  IN_OUTBOUND = 71,
  // 待入库
  WAIT_ENTRY = 80,
  // 已完成
  DONE = 100
}

export enum FilmPurchaseOrderEventEnum {
  // 退回
  REJECT = -1,
  // 暂存
  SAVE = 10,
  // 提交
  SUBMIT = 20,
  // 撤销
  REVERT = 21,
  // 审核通过
  AUDIT_RESOLVE = 30,
  // 审核拒绝
  AUDIT_REJECT = 31,
  // 甲方签订合同
  FIRST_PARTY_SIGN = 35,
  // 乙方签订合同
  SECOND_PARTY_SIGN = 40,
  // 合同审核
  AUDIT_SIGN = 50,
  // 采购
  PURCHASE = 60,
  // 采购出库
  PURCHASE_OUTBOUND = 70,
  // 出库
  OUTBOUND = 80,
  // 入库
  ENTRY = 90,
  // 集采入库
  GROUP_ORDER_ENTRY = 100
}

/** 车膜销售订单发货方式枚举 */
export enum FilmPurchaseOrderDeliveryTypeEnum {
  ZONG_BU = 1,
  BEN_BU = 2
}

/** 车膜库存状态 */
export enum FilmInventoryStatusEnum {
  IN_STOCK = 1,
  WAITING_OUT = 2,
  OUT = 3
}

/** 车辆分类 */
export enum VehicleCategoryEnum {
  /** 轿车 */
  SEDAN = 1,
  /** SUV */
  SUV = 2,
  /** MPV */
  MPV = 3,
  /** 皮卡 */
  PICKUP = 4,
  /** 商务车 */
  BUSINESS = 5,
  /** 跑车 */
  SPORTS = 6,
  /** 越野 */
  OFFROAD = 7
}

export enum EffectiveRangeEnum {
  /** 一次性 */
  ONCE = 1,
  /** 长期 */
  LONG_TERM = 2
}

export enum ProductEffectiveRangeEnum {
  /** 一次性 */
  ONCE = 1,
  /** 本车型 */
  ONE_CATEGORY = 2,
  /** 所有车型 */
  ALL_CATEGORY = 3
}

/** 消息通知类型枚举 */
export enum NotificationTypeEnum {
  /** 系统通知 */
  SYSTEM = 0,
  /** 销售订单 */
  SALE_ORDER = 1,
  /** 车模采购订单 */
  FILM_PURCHASE_ORDER = 2,
  /** 商品采购订单 */
  STORE_PURCHASE_ORDER = 3,
  /** 大客户流转 */
  STORE_CUSTOMER_TRANSFER = 4,
  /** 客户预约 */
  STORE_APPOINTMENT = 5,
  /** 商品库存 */
  PRODUCT_INVENTORY = 6,
  /** 车膜库存 */
  FILM_INVENTORY = 7
}
/** 消息通知动作枚举 */
export enum NotificationActionEnum {
  /** 待办 */
  TODO = 1,
  /** 通知 */
  NOTIFY = 2
}
/** 事件类型枚举 */
export enum SseEventTypeEnum {
  CONNECT = 'CONNECT',
  HEARTBEAT = 'HEARTBEAT',
  /** 用户消息统计 */
  NOTIFY_STATISTICS = 'NOTIFY_STATISTICS',
  /** 新消息 */
  NOTIFY_NEW = 'NOTIFY_NEW',
  /** 消息已读 */
  NOTIFY_READ = 'NOTIFY_READ'
}

/** 采购订单支付方式 */
export enum OrderPaymentMethodEnum {
  // 微信
  WECHAT = 1,
  // 支付宝
  ALIPAY = 2,
  // 银行卡
  BANK = 3,
  // 挂账
  PENDING = 4
}

export enum InventoryPurchaseModeEnum {
  // 线上采购
  ONLINE = 1,
  // 线下采购
  OFFLINE = 2
}
